/* React */
import React from 'react';

/* Translation */
import { useTranslation } from 'react-i18next';

/* Styled Components */
import {
  Illustration,
  Wrapper,
  Caption,
} from './styles';

export interface AddClassroomSuccessViewProps {}

const AddClassroomSuccessView: React.FC<AddClassroomSuccessViewProps> = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Illustration />
      <Caption>{t('settings:CENTER_SECTION.CLASSROOM_CONFIG.ADDED_CLASSROOM')}</Caption>
    </Wrapper>
  );
};

export default AddClassroomSuccessView;
